import React, { forwardRef, JSX } from 'react';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { IconBaseProps } from 'react-icons/lib';
import { WHATSAPP_BOOKING_URL } from '../constants/contact';

// @ts-ignore react-icons types are not fully aligned with this React version.
const WhatsAppIcon = forwardRef<SVGSVGElement, IconBaseProps>((props, ref) => <FaWhatsapp {...props} ref={ref} /> as JSX.Element);
WhatsAppIcon.displayName = 'WhatsAppIcon';

const FloatingLink = styled.a`
    position: fixed;
    right: clamp(1rem, 2.5vw, 2rem);
    bottom: clamp(1rem, 2.5vw, 2rem);
    z-index: 1000;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.65rem;
    min-height: 3.25rem;
    padding: 0 1.25rem 0 1rem;
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 999px;
    background: #25d366;
    color: #ffffff;
    box-shadow: 0 16px 35px rgba(37, 211, 102, 0.32), 0 8px 18px rgba(15, 23, 42, 0.18);
    font-size: 1rem;
    font-weight: 800;
    line-height: 1;
    text-decoration: none;
    animation: whatsappCtaIn 0.35s ease-out both;
    transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

    @keyframes whatsappCtaIn {
        from {
            opacity: 0;
            transform: translateY(18px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    svg {
        width: 1.35rem;
        height: 1.35rem;
        flex: 0 0 auto;
    }

    span {
        white-space: nowrap;
    }

    &:hover {
        background: #1ebe5d;
        box-shadow: 0 18px 40px rgba(37, 211, 102, 0.38), 0 10px 20px rgba(15, 23, 42, 0.2);
        transform: translateY(-2px);
    }

    &:active {
        transform: scale(0.97);
    }

    &:focus-visible {
        outline: 3px solid rgba(251, 191, 36, 0.9);
        outline-offset: 4px;
    }

    @media (max-width: 520px) {
        right: 1rem;
        left: 1rem;
        bottom: 1rem;
        min-height: 3.5rem;
        padding: 0 1rem;
        font-size: 0.98rem;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
        transition: none;
    }
`;

const FloatingWhatsAppCTA: React.FC = () => {
    return (
        <FloatingLink
            href={WHATSAPP_BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Book via WhatsApp"
        >
            <WhatsAppIcon aria-hidden="true" />
            <span>Book via WhatsApp</span>
        </FloatingLink>
    );
};

export default FloatingWhatsAppCTA;
